import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript/";
import { StripePaymentMethodMessagingElement, StripePaymentMethodMessagingElementOptions } from "@stripe/stripe-js";
import { amountToMinorUnits, getOrderStore, getStripeStore } from "../utils";
import { ProductContextComponent } from "../product-context.component";
import { AmountDto } from "../api";

export class StripeMessagingComponent extends AlpineComponent {
    private productContextComponent?: ProductContextComponent | null = null;
    private stripeMessagingElement?: StripePaymentMethodMessagingElement | null = null;

    public messagingElementAvailable: boolean = true;
    public messagingElementMounted: boolean = false;

    constructor() {
        super();
        const orderStore = getOrderStore();

        if(orderStore.transactionAmount?.value ?? 0 === 0) {
            this.messagingElementAvailable = false;
        }
    }

    async init() {
        this.productContextComponent = this.$data  as unknown as ProductContextComponent;
        if(!this.productContextComponent.addToCart) {
            this.productContextComponent = undefined;
        }

        window.Alpine.effect(() => {
            //It appears the stripe messaing element does not support updates on unmounting.
            const productTotalPrice = this.getProductTotalPrice();
            this.handleTransactionAmountUpdated(productTotalPrice ?? { value: 0, formatted: { value: "0.00" }});
        });

        this.$watch("$store.stripe.stripeReady", (newValue) => {
            if(newValue === true) {
                this.setupElement();
                this.mount();
            }
        });
    }

    setupElement(){
        const orderStore = getOrderStore();
        const stripeStore = getStripeStore();
        const totalPrice = this.getProductTotalPrice();
        if(stripeStore.stripeReady && totalPrice) {
            const elements = stripeStore.getStripeElements();
            if(elements && !this.stripeMessagingElement) {
                this.stripeMessagingElement = elements.create("paymentMethodMessaging", {
                    amount: amountToMinorUnits(totalPrice.value),
                    currency: orderStore.currencyCode.toUpperCase()
                } as StripePaymentMethodMessagingElementOptions);
                this.messagingElementAvailable = true;
            }
        }
    }

    mount() {
        if(this.stripeMessagingElement && getStripeStore().stripeReady && !this.messagingElementMounted) {
            this.stripeMessagingElement.mount(this.$refs["stripe-payment-messaging-container"]);
            this.messagingElementMounted = true;
        }
    }

    private getProductTotalPrice() : AmountDto | null | undefined {
        const calculatedTotalAmount = this.productContextComponent?.calculatedTotalAmount;
        if(calculatedTotalAmount) {
            return calculatedTotalAmount;
        } else {
            const orderStore = getOrderStore();
            return orderStore.transactionAmount;
        }
    }

    handleTransactionAmountUpdated(newValue: AmountDto) {
        if(this.stripeMessagingElement) {
            console.debug("Updating Stripe Messaging Element with new amount:", newValue.value);
            this.stripeMessagingElement.update({
                amount: amountToMinorUnits(newValue.value),
            });
            this.mount();
        } else {
            this.setupElement();
            this.mount();
        }
    }
}